export const uniqStable = (ids: number[]) => {
	const seen = new Set<number>();
	const out: number[] = [];
	for (const id of ids) {
		if (!seen.has(id)) {
			seen.add(id);
			out.push(id);
		}
	}
	return out;
};
